import { useQuery } from "@apollo/client";
import useCapabilities, { useCanViewTasksBool } from "@/hooks/useCapabilities";
import useEffectiveDisplayUser from "@/hooks/useEffectiveDisplayUser";
import { OPEN_TASK_COUNT_QUERY, openMyTaskCountVariables, openTeamTaskCountVariables } from "@/pages/tasks/queries";

export default function useOpenTaskCount(): number | null {
  const { id: currentUserId } = useCapabilities();
  const canViewTasks = useCanViewTasksBool();
  const { department } = useEffectiveDisplayUser();
  const teamName = department?.trim() ?? "";
  const skipMyTasks = !currentUserId || !canViewTasks;
  const skipTeamTasks = !teamName || !canViewTasks;

  const { data: myData } = useQuery(OPEN_TASK_COUNT_QUERY, {
    variables: openMyTaskCountVariables(currentUserId ?? ""),
    skip: skipMyTasks,
    fetchPolicy: "cache-and-network"
  });

  const { data: teamData } = useQuery(OPEN_TASK_COUNT_QUERY, {
    variables: openTeamTaskCountVariables(teamName),
    skip: skipTeamTasks,
    fetchPolicy: "cache-and-network"
  });

  if (skipMyTasks && skipTeamTasks) return null;
  if (!skipMyTasks && myData == null) return null;
  if (!skipTeamTasks && teamData == null) return null;

  const myCount = skipMyTasks ? 0 : (myData?.tasks?.totalCount ?? 0);
  const teamCount = skipTeamTasks ? 0 : (teamData?.tasks?.totalCount ?? 0);
  return myCount + teamCount;
}
